var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef } from "react";
var Breadcrumb = forwardRef(function (_a, ref) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "id", "className", "style"]);
    var _b = useState(false), displayMobileBreadcrumbs = _b[0], setDisplayMobileBreadcrumbs = _b[1];
    var classCollapse = "fr-collapse";
    if (displayMobileBreadcrumbs) {
        classCollapse += " fr-collapse--expanded";
    }
    return (React.createElement("nav", __assign({}, otherProps, { role: "navigation", className: "fr-breadcrumb ".concat(className ? className : ""), style: style, ref: ref, "aria-label": "Vous \u00EAtes ici" }),
        React.createElement("button", { type: "button", className: "fr-breadcrumb__button", "aria-expanded": displayMobileBreadcrumbs, "aria-controls": id, onClick: function () { return setDisplayMobileBreadcrumbs(!displayMobileBreadcrumbs); } }, "Voir le fil d'Ariane"),
        React.createElement("div", { className: classCollapse, id: id, style: { maxHeight: "none" } },
            React.createElement("ol", { className: "fr-breadcrumb__list" }, children))));
});
export default Breadcrumb;
